var render = function (_h,_vm) {var _c=_vm._c;return (!_vm.props.isAvailable)?_c('div',{class:_vm.$style.disabled},[_vm._v(" N/A ")]):_c('div',{class:_vm.props.isSelected ? _vm.$style.selected : _vm.$style.unselected,on:{"click":function($event){return _vm.props.toggle()}}},[_vm._v(" "+_vm._s(_vm.props.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }